import { createFileRoute } from '@tanstack/react-router'

import { PaginaLoteFrango } from '@/features/frango/pagina-lote'

export const Route = createFileRoute('/$perfil/frango/lote/$projeto/$iid')({
  component: Tela,
})

function Tela() {
  const { perfil, projeto, iid } = Route.useParams()
  return <PaginaLoteFrango perfil={perfil} projeto={projeto} iid={iid} />
}
